<template>
    <div class="rule">
        <div class="header">
            <i @click="goback"> <img src="./../../../assets/home/back.jpg" alt=""> </i>
            <span>用户协议</span>
        </div>
        <div class="imgBox"><img src="./../../../assets/rule/1.jpg" alt=""></div>
        <div class="imgBox"><img src="./../../../assets/rule/2.jpg" alt=""></div>
        <div class="imgBox"><img src="./../../../assets/rule/3.jpg" alt=""></div>
        <div class="imgBox"><img src="./../../../assets/rule/4.jpg" alt=""></div>
        <div class="imgBox"><img src="./../../../assets/rule/5.jpg" alt=""></div>
        <div class="imgBox"><img src="./../../../assets/rule/6.jpg" alt=""></div>
        <div class="imgBox"><img src="./../../../assets/rule/7.jpg" alt=""></div>
        <div class="imgBox"><img src="./../../../assets/rule/8.jpg" alt=""></div>
        <div class="imgBox"><img src="./../../../assets/rule/9.jpg" alt=""></div>
        <div class="imgBox"><img src="./../../../assets/rule/10.jpg" alt=""></div>
        <div class="imgBox"><img src="./../../../assets/rule/11.jpg" alt=""></div>
    </div>
</template>

<script>

export default {
    methods:{
        goback(){
            this.$router.go(-1)
        },
        
    }
}
</script>
<style lang="scss" scoped>
    .imgBox{
        width:100%;
    }
    .header{
        width:90%;
        height:.40rem;
        margin-left: 5%;
        display: flex;
        justify-content: center;
        align-items: center;
        position:relative;
        span{
            font-size: .18rem;
            line-height: .40rem;
        }
        i{
            position:absolute;
            left:0.05rem;
            width:.26rem;
            height:.16rem;
            padding-right:.16rem;
        }
    }
</style>
